import { useMutation } from '@tanstack/react-query';
import * as actions from './actions';

export function useUpdateSessionParticipantAssessmentToken() {
    return useMutation(actions.updateSessionParticipantAssessmentToken);
}
  